"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tooltip = _interopRequireDefault(require("../../tooltip"));

var _utils = require("../utils");

// eslint-disable-next-line import/no-cycle
var BodyCell = function BodyCell(_ref) {
  var cellData = _ref.cellData,
      column = _ref.column,
      isScrolling = _ref.isScrolling;
  var truncateText = column.truncateText,
      tooltip = column.tooltip;
  var tooltipResult = (0, _utils.isFunction)(tooltip) ? tooltip(cellData) : null;
  var tooltipConfig = {
    text: String(cellData)
  };

  if (tooltipResult) {
    if ((0, _utils.isString)(tooltipResult) || (0, _utils.isFunction)(tooltipResult)) {
      tooltipConfig = {
        text: tooltipResult
      };
    }
    /* istanbul ignore else */


    if ((0, _utils.isObject)(tooltipResult)) {
      tooltipConfig = tooltipResult;
    }
  }
  /* istanbul ignore else */


  if (tooltipConfig.text) {
    if (truncateText) {
      return isScrolling ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-text-truncate"
      }, cellData) : /*#__PURE__*/_react["default"].createElement(_tooltip["default"], (0, _extends2["default"])({
        overflowOnly: true
      }, tooltipConfig), /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-text-truncate"
      }, cellData));
    }

    if (tooltipResult && !isScrolling) {
      return /*#__PURE__*/_react["default"].createElement(_tooltip["default"], tooltipConfig, /*#__PURE__*/_react["default"].createElement("div", null, cellData));
    }
  }

  return cellData;
};

BodyCell.propTypes = {
  cellData: _propTypes["default"].any,
  column: _propTypes["default"].object,
  isScrolling: _propTypes["default"].bool
};
var _default = BodyCell;
exports["default"] = _default;